import store from '@/store';

export default class RemoveWhatsAppEvent {
  constructor(event) {
    const protocol = event.body.protocol;
    if (protocol) {
      store.dispatch('jobs/removeJob', protocol);
      store.dispatch('showSnackbar', { text: 'jobFinished' }, { root: true });
      const agentId = store.getters['attendance/attendance'].agentId;
      store.dispatch('attendance/getStatusAgent', agentId);
    }
  }
}
